import { generateNamespace } from "~/utils/HelmCommands/HelmCommandHelperMethods";

export function generateAgentAsTargetNamespace(agentName: string): string {
    return generateNamespace(agentName, "octopus-agent");
}

export function generateAgentAsWorkerNamespace(agentName: string): string {
    return generateNamespace(agentName, "octopus-worker");
}
